<app-loader-common></app-loader-common>
<div class="layout-body">
    <router-outlet></router-outlet>
</div>

